import { RootState } from '../../../index';
import { ShippingLookaheadKeys } from './types';

export const selectShippingSearchState = (state: RootState) =>
  state.shipping.search;

export const selectShippingLookAheadOption = (state: RootState) =>
  selectShippingSearchState(state).lookAheadOption;

export const selectShippingLookAheadOptionType = (state: RootState) =>
  selectShippingSearchState(state).lookAheadOptionType;

export const selectShippingSearchByKey =
  (key: ShippingLookaheadKeys) => (state: RootState) =>
    selectShippingSearchState(state)[key];
